module.exports = __webpack_public_path__ + "assets/images/paper-pencil-icon.3712c36295c7377c0fba87ee84cf0c0b.svg";